import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=7c9a0c27&scoped=true&"
import script from "./Exception.vue?vue&type=script&lang=ts&"
export * from "./Exception.vue?vue&type=script&lang=ts&"
import style0 from "./Exception.vue?vue&type=style&index=0&id=7c9a0c27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9a0c27",
  null
  
)

export default component.exports